/* Tabs for the NAD3 ES clinical trial and timeline sections.
   Markup: [data-lp-tabs] > [data-tab="i"] buttons + [data-panel="i"] panels. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__lpTabsReady) return;
    root.__lpTabsReady = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    if (!tabs.length) return;

    function activate(index, focus) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-tab') === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) tab.focus();
        if (on) {
          var strip = tab.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: tab.offsetLeft - strip.clientWidth / 2 + tab.clientWidth / 2, behavior: 'smooth' });
          }
        }
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-panel') === String(index);
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-tab'), false);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        activate(tabs[next].getAttribute('data-tab'), true);
      });
    });

    root.querySelectorAll('[data-tab-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = 0;
        tabs.forEach(function (t, k) { if (t.classList.contains('is-active')) current = k; });
        var dir = Number(btn.getAttribute('data-tab-step')) || 1;
        var next = Math.min(tabs.length - 1, Math.max(0, current + dir));
        activate(tabs[next].getAttribute('data-tab'), false);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-lp-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[data-lp-tabs]');
    if (el) init(el);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest('[data-lp-tabs]');
    if (!root) return;
    var panel = e.target.closest('[data-panel]');
    var index = panel ? panel.getAttribute('data-panel') : e.target.getAttribute('data-panel');
    if (index === null || index === undefined) return;
    var tab = root.querySelector('[data-tab="' + index + '"]');
    if (tab) tab.click();
  });
})();
